const POSTHOG_API_KEY = process.env.POSTHOG_API_KEY ?? '';

export default POSTHOG_API_KEY;
